import { EmptyState, MenuDots } from '../../../../Components/icons';
import {
  CardContainer,
  CardContent,
  CardTextBig,
  CardTextBottom,
  CardTextLight,
} from '../dashboard.style';
import {
  EmptyStateContainer,
  StyledEmptyStateText,
} from '../../../../Components/uielements/table/table.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { convertToUserTimeZoneDateTime } from '../../../../helper/dataFormat';
import { useMemo } from 'react';

const DashboardTable = (props) => {
  const { data: rawData = [] } = props;

  const normalizedData = useMemo(() => {
    if (!rawData) return [];

    if (Array.isArray(rawData)) {
      return rawData;
    }

    if (rawData.data && Array.isArray(rawData.data)) {
      return rawData.data;
    }

    return [];
  }, [rawData]);

  const userTimeZone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

  const isEmpty = normalizedData.length === 0;

  return (
    <>
      {isEmpty && (
        <div
          style={{
            display: 'grid',
            justifyContent: 'center',
            alignItems: 'center',
            gridAutoFlow: 'row',
          }}
        >
          <EmptyStateContainer>
            <EmptyState />
          </EmptyStateContainer>
          <StyledEmptyStateText size="header3">
            <IntlMessages id="common.empty.state" defaultMessage="No Record Found" />
          </StyledEmptyStateText>
        </div>
      )}
      <CardContainer>
        {normalizedData?.map((item, index) => (
          <CardContent key={item?.id || index}>
            <div style={{ display: 'grid', height: 'fit-content', gap: '5px' }}>
              <CardTextBig>
                {`${item?.userId?.firstName || ''} ${item?.userId?.lastName || ''}`.trim()}
              </CardTextBig>
              <CardTextLight>
                Geo - {item?.geofenceId?.name || 'N/A'}, Premise -{' '}
                {item?.premiseId?.propertyName || 'N/A'}
              </CardTextLight>
              <CardTextBottom>
                <span>IN:</span>{' '}
                {item?.entryDate
                  ? convertToUserTimeZoneDateTime(item?.entryDate, userTimeZone)
                  : '--'}{' '}
                <span>OUT:</span>{' '}
                {item?.exitDate
                  ? convertToUserTimeZoneDateTime(item?.exitDate, userTimeZone)
                  : '--'}
              </CardTextBottom>
            </div>
            <MenuDots />
          </CardContent>
        ))}
      </CardContainer>
    </>
  );
};

export default DashboardTable;
